module.exports = __webpack_public_path__ + "html/section-company-quote_ae9ee22cc3e2cd7387921110c1a747c4.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-company-quote.html
// module id = 1ps6
// module chunks = 65